<template>
  <v-container ma-0 fluid grid-list-sm class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Scheduled Reminders
      </v-flex>
      <utility-backButton/>

      <v-dialog v-model="reminderDialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="title">
            {{ selectedTimerObject.title }}
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md pa-0>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                    label="What day"
                    :items="daySelection"
                    placeholder="Select day of week"
                    v-model="selectedTimerObject.day"
                    dense
                    outline
                  />
                </v-flex>
                <v-flex xs6>
                  <v-select
                    label="Time"
                    :items="timeOfDayList"
                    placeholder="Select time to send"
                    v-model="selectedTimerObject.time"
                    dense
                    outline
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn medium block color="blueBackground" @click="saveSchedule" :disabled="saveClicked" :loading="saveClicked">
              Save new schedule
            </v-btn>
            <v-btn medium block color="pipefishDarkBlue" @click="reminderDialog = false">
              Cancel
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
      <!-- DIALOG FINISHED -->
      

      <v-container grid-list-xl>
        <v-layout column>
          <v-flex>
            <v-card class="elevation-2">
              <v-card-title>
                <div>
                  <div class="title">
                    Scheduled timesheet reminder
                  </div>
                  <div class="caption">
                    Email reminders are automatically sent to all staff 
                  </div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md style="padding:0px">
                  <v-layout wrap>
                    <v-flex xs6>
                      <div>
                        <div class="caption font-weight-bold">
                          Current reminder schedule
                        </div>
                        <div class="caption font-weight-thin">
                          <!-- Every 5 seconds -->
                          <v-progress-circular
                            :size="30"
                            :width="3"
                            color="pipefishBlack"
                            indeterminate
                            v-show="reminderTimer.loading"
                          ></v-progress-circular>
                          {{reminderTimer.current}}
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption font-weight-bold">
                          Next Scheduled Date
                        </div>
                        <div class="caption font-weight-thin">
                          <v-progress-circular
                            :size="30"
                            :width="3"
                            color="pipefishBlack"
                            indeterminate
                            v-show="reminderTimer.loading"
                          ></v-progress-circular>
                          {{reminderTimer.nextDate}}
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn medium color="blueBackground" @click="openDialog(reminderTimer)">
                  Change reminder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex>
            <v-card class="elevation-2">
              <v-card-title>
                <div>
                  <div class="title">
                    Scheduled Approval Timer
                  </div>
                  <div class="caption">
                    Email are automatically sent to managers to approve staff timesheets.<br>
                    <span class="red--text"> Ensure this date is after the staff timesheet reminder. </span>
                  </div>
                </div>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md style="padding:0px">
                  <v-layout wrap>
                    <v-flex xs6>
                      <div>
                        <div class="caption font-weight-bold">
                          Current reminder schedule
                        </div>
                        <div class="caption font-weight-thin">
                          <v-progress-circular
                            :size="30"
                            :width="3"
                            color="pipefishBlack"
                            indeterminate
                            v-show="approvalTimer.loading"
                          ></v-progress-circular>
                          {{approvalTimer.current}}
                        </div>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div>
                        <div class="caption font-weight-bold">
                          Next Scheduled Date
                        </div>
                        <div class="caption font-weight-thin">
                          <v-progress-circular
                            :size="30"
                            :width="3"
                            color="pipefishBlack"
                            indeterminate
                            v-show="approvalTimer.loading"
                          ></v-progress-circular>
                          {{approvalTimer.nextDate}}
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn medium color="blueBackground" @click="openDialog(approvalTimer)">
                  Change reminder
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

        <v-flex xs12>
          <v-layout justify-center pt-5 pb-5>
            <v-flex xs6>
              <material-card class="v-card-profile">
                <v-avatar
                  slot="offset"
                  class="mx-auto d-block elevation-5"
                  size="90"
                  style="border: 0px solid black; backgroundColor: white"
                >
                  <v-icon large color="orange">
                    mdi-email-alert
                  </v-icon>
                </v-avatar>
                <v-card-text>
                  <div class="text-xs-center">
                    Select multiple users and send an email reminder to all of them
                    <br>
                    <v-btn outline small color="pipefishGreen" @click="emailDialog = true">
                      Send reminders
                      <v-icon right>
                        mdi-bell
                      </v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </material-card>
            </v-flex>
          </v-layout>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data: () => ({
    saveClicked: false,
    selectedTimerObject: {},
    reminderDialog: false,
    reminderTimer: {
      isReminder: true,
      title: 'Email Reminder Schedule',
      current: '', // store current setting description
      day: '', // selected DAY to update to
      time: '', // selected TIME to update to
      nextDate: '', // store next scheduled date
      schedule: '', // schedule, the whole function.json
      loading: true // show loading
    },
    approvalTimer: {
      isReminder: false,
      title: 'Approval Emails Schedule',
      current: '',
      day: '',
      time: '',
      nextDate: '',
      schedule: '',
      loading: true
    },
    daySelection: [
      {text: 'Sunday', value: 0},
      {text: 'Monday', value: 1},
      {text: 'Tuesday', value: 2},
      {text: 'Wednesday', value: 3},
      {text: 'Thursday', value: 4},
      {text: 'Friday', value: 5},
      {text: 'Saturday', value: 6}
    ],
    emailDialog: false,
  }),
  computed: {
    timeOfDayList: function() {
      var result = []
      for(var i = 0; i < 24; i++) {
        result.push({
          text: `${i}:00`,
          value: i
        })
      }
      return result
    }
  },
  created() {

    // Get the current timer schedule
    // using the cron expression, calculate the next scheduled date 
    this.getCurrentSetting(true)
    this.getCurrentSetting(false)

  },
  methods: {
    updateTime() {
      var self = this
      this.$timesheetApi.updateTimerTime(this.newValue).then(response => {
        // console.log(response)
        self.$timesheetApi.getTimerTime().then(response => {
          self.timerValue = response.bindings[0].schedule
          self.newValue = ''
        })
      })
    },
    nextDateReminder(timer) { // timer is reminderTimer or approvalTimer
      var self = this
      var cronExp = timer.schedule.bindings[0].schedule.split(" ")


      const dayINeed = parseInt(cronExp[5]);
      const today = moment().isoWeekday();

      var nextScheduledDate = null
      // if we haven't yet passed the day of the week that I need:
      if (today <= dayINeed) { 
        // then just give me this week's instance of that day
        nextScheduledDate = moment().isoWeekday(dayINeed)
      } else {
        // otherwise, give me *next week's* instance of that same day
        nextScheduledDate = moment().add(1, 'weeks').isoWeekday(dayINeed)
      }

      nextScheduledDate.minute(0)
      nextScheduledDate.second(0)
      nextScheduledDate.hour(parseInt(cronExp[2]))
      timer.nextDate = nextScheduledDate.format('LLLL')
    },
    getCurrentSetting(isReminder) {
      var self = this
      if(isReminder) {
        this.$timesheetApi.getReminderTimer().then(response => {
          self.updateView(self.reminderTimer, response)
          self.saveClicked = false
        })
      } else {
        this.$timesheetApi.getApprovalTimer().then(response => {
          self.updateView(self.approvalTimer, response)
          self.saveClicked = false
        })
      }
    },
    updateView(timerObject, response) {
      timerObject.current = response.desc
      timerObject.schedule = response.schedule
      timerObject.loading = false
      timerObject.day = ''
      timerObject.time = ''
      this.nextDateReminder(timerObject)
    },
    openDialog(timer) {
      this.selectedTimerObject = timer
      this.reminderDialog = true
    },
    saveSchedule() {
      this.selectedTimerObject.loading = true
      this.saveClicked = true
      var self = this
      var cronExpression = `0 0 ${this.selectedTimerObject.time} * * ${this.selectedTimerObject.day}`
      var schedule = this.selectedTimerObject.schedule
      schedule.bindings[0].schedule = cronExpression

      if(this.selectedTimerObject.isReminder) {
        // make API call to update reminder timer
        self.$timesheetApi.updateReminderTime(schedule).then(response => {
          // console.log(response)
          self.getCurrentSetting(self.selectedTimerObject.isReminder)
          self.reminderDialog = false
        })

      } else {
        // make API call to update approval timer
        self.$timesheetApi.updateApprovalTime(schedule).then(response => {
          // console.log(response)
          self.getCurrentSetting(self.selectedTimerObject.isReminder)
          self.reminderDialog = false
        })
      }

      // this.reminderDialog = false
    }
  }
}
</script>

<style>
</style>
